import React, { PropsWithChildren, useRef } from 'react';

import { getFile } from '../../Service/ApiService';

type Props = PropsWithChildren<any> & {
    url: string;
    className?: string;
};

export const DownloadLink: React.FC<Props> = ({ url, className, children }) => {
    const link = useRef<HTMLAnchorElement>(null);

    const handleAction = async (): Promise<void> => {
        if (!link.current || link.current.href) {
            return;
        }

        const { blob } = await getFile(url);
        link.current.href = window.URL.createObjectURL(blob);
        link.current.click();
    };

    return (
        <a
            role="button"
            target="_blank"
            ref={link}
            onClick={handleAction}
            onKeyDown={handleAction}
            className={className}
        >
            {children}
        </a>
    );
};
